import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'fileExtension',
})
export class FileExtensionPipe implements PipeTransform {

  transform(fileName: string): string {
    if (fileName?.includes('.')) {
        const t = fileName?.split('.')?.slice(0, -1)?.toString()
        return t;
    }

    return fileName;
  }

}
